import KioskQuantityPicker from './KioskQuantityPicker.jsx';

export default KioskQuantityPicker;


// WEBPACK FOOTER //
// ./src/components/KioskQuantityPicker/index.jsx